(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaoInsumoController',AquisicaoInsumoController);

    AquisicaoInsumoController.$inject = ['$uibModalInstance', 'entity', 'Aquisicao','Localarmazenamento', 'Insumo'];

    function AquisicaoInsumoController($uibModalInstance, entity, Aquisicao, Localarmazenamento, Insumo) {
        var vm = this;

        vm.aquisicao = entity;
        vm.insumo = insumo;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.clear = clear;

        vm.insumo.nome = vm.aquisicao.produtoaquisitado;
        vm.localarmazenamentos = Localarmazenamento.query();
        vm.insumo.aquisicao = vm.aquisicao.id;
        
        vm.armazenados = Insumo.query();

        vm.armazenados.$promise.then(function(data){
            var i = 0;
            vm.aquisicao.restante = vm.aquisicao.quantidade;
            
            for(i=0; i<data.length; i++){
                if(data[i].aquisicao.id === vm.aquisicao.id){
                    vm.aquisicao.restante = vm.aquisicao.restante - data[i].quantidadearmazenada;
                }
            }
            if(vm.aquisicao.restante===0){
                vm.ativado=true;
            }
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function insumo(id){
            vm.novoinsumo = new Insumo();
            vm.novoinsumo.quantidadearmazenada = vm.insumo.quantidadearmazenada;
            vm.novoinsumo.dataentrada = new Date(vm.insumo.dataentrada);
            vm.novoinsumo.aquisicao = new Aquisicao();
            vm.novoinsumo.aquisicao.id = id;
            vm.novoinsumo.quantidadedisponivel = vm.novoinsumo.quantidadearmazenada;
            vm.novoinsumo.localarmazenamento = new Localarmazenamento();
            vm.novoinsumo.localarmazenamento.id = vm.insumo.localarmazenamento.id;
            vm.novoinsumo.localarmazenamento.nomelocal = vm.insumo.localarmazenamento.nomelocal;
            vm.novoinsumo.nome = vm.insumo.nome + " em " + vm.insumo.localarmazenamento.nomelocal;

            console.log(vm.novoinsumo);
            Insumo.save(vm.novoinsumo, onSaveSuccess, onSaveError);
        }

        vm.datePickerOpenStatus.dataentrada = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

    
        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();
